import { get, isEmpty } from 'lodash'
import { createSelector } from 'reselect'

export const getCurrentConfiguration = (state) => get(state, 'config')

export const getResourceList = (state) => get(state, 'config.resourceList', {})

export const getDeviceSubtype = (state) => get(state, 'config.deviceSubtype')

export const getControlledPrinterUuids = (state) => {
  return get(state, 'config.configuration.controlledPrinterUuids', [])
}

export const getIsPrintController = (state) => {
  return !isEmpty(getControlledPrinterUuids(state))
}

export const getSelectedMenusIds = (state) => state?.config?.configuration?.menuUuids ?? []

export const getDeviceAllowList = (state) => state?.config?.whitelist ?? ['https://www.google.com', 'https://fast.com']

export const getShouldWaitForRedirect = (state) => state?.config?.shouldWaitForRedirect ?? false

export const getBackbarMode = (state) => state?.config?.backbarMode ?? false

/**
 * Checks for network availability based off of `useNetworkIsAvailable` ping for `blank.png`
 */
export const getNetworkAvailable = createSelector(getCurrentConfiguration, (state) => state?.networkAvailable ?? false)
